import styled from "@emotion/styled";

import InputBlurChange from "./InputBlurChange";

export const NumericInputBlurChange = styled(InputBlurChange)`
  width: auto;
`;
